// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__23HUa","left":"InfoRow_left__14X24"};